// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@stoneage/Overrides/Widgets/Basic/Subscribe";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 12,
    css: css`
        width: 100%;
        display: flex;
        text-align: left;
    `,
};

subscribeStyles.emailGridItem = {
    width: 12,
    css: css`
        padding-top: 16px;
        text-align: left;
    `,
};

subscribeStyles.titleGridItem = {
    width: 12,
    css: css`
        color: ${color("common.white")};
    `,
};

subscribeStyles.titleLabel = {
    variant: "h5",
    css: css`
        color: ${color("common.white")};
        margin-bottom: -5px;
    `,
};

subscribeStyles.descriptionGridItem = {
    width: 12,
};

subscribeStyles.descriptionText = {
    css: css`
        color: ${color("common.ui5")};
        & p {
            font-size: 12px;
            margin-bottom: 10px;
        }
    `,
};

subscribeStyles.emailTextField = {
    css: css`
        height: 100%;
        flex-grow: 2;
    `,
};

subscribeStyles.emailButton = {
    shape: "rounded",
    sizeVariant: "small",
    typographyProps: {
        size: 12,
        css: css`
            padding: 0 4px;
        `,
    },
    css: css`
        min-height: 26px;
        position: absolute;
        right: 3px;
        top: 4px;
        & span:nth-child(2) {
            display: none;
        }
    `,
};

subscribeStyles.disclaimerGridItem = {
    width: 12,
};

subscribeStyles.disclaimerText = {
    css: css`
        font-size: 12px;
    `,
};

subscribeStyles.buttonCustom = {
    css: css`
        width: 100%;
        display: flex;
        position: relative;
    `,
};

subscribeStyles.externalProviderButton = {
    shape: "rounded",
    sizeVariant: "small",
    typographyProps: {
        size: 12,
        css: css`
            padding: 0 4px;
        `,
    },
    css: css`
        width: 100%;
    `,
};
